import { isChannel } from "@website/utils/channel/helpers";

export const useFooter = () => {
  const onClickEnamad = () => {
    if (window) {
      window.open(
        "https://trustseal.enamad.ir/?id=83827&Code=RBoh3Kq5s0Z8xE4tbcG",
        "Popup",
        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
      );
    }
  };

  const onClickSamandehi = () => {
    if (window) {
      window.open(
        "https://logo.samandehi.ir/Verify.aspx?id=128793&p=rfthuiwkmcsijyoepfvlxlao",
        "Popup",
        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
      );
    }
  };

  const onClickEcunion = () => {
    if (window) {
      window.open(
        `https://ecunion.ir/verify/snapptrip.com?token=44328795b1d0308e6e2b`,
        "Popup",
        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
      );
    }
  };

  const onClickFarasa = () => {
    if (window) {
      window.open(
        "https://farasa.cao.ir/sysworkflow/fa/modern/3810212626028ab03488017019616799/6464336316028ab04e3c618028352200.php",
        "Popup",
        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
      );
    }
  };

  return {
    certificates: isChannel(["snapp-ir", "ads"])
      ? []
      : [
          {
            // referrerPolicy: "origin",
            id: "RBoh3Kq5s0Z8xE4tbcGh",
            onClick: onClickEnamad,
            alt: "logo-enamad",
            src: "https://trustseal.enamad.ir/logo.aspx?id=83827&Code=RBoh3Kq5s0Z8xE4tbcGh",
            width: 150,
            height: 150
          },
          {
            // referrerPolicy: "origin",
            id: "jxlznbqeoeukjzpesizprgvj",
            onClick: onClickSamandehi,
            alt: "logo-samandehi",
            src: "https://logo.samandehi.ir/logo.aspx?id=128793&p=nbpdodrfaqgwyndtbsiyqfti",
            width: 150,
            height: 150
          },
          {
            title: "ecunion logo",
            alt: "ecunion logo",
            id: "44328795b1d0308e6e2b",
            src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+",
            width: 240,
            height: 360,
            onClick: onClickEcunion
          },
          {
            title: "farasa logo",
            alt: "farasa logo",
            id: "6464336316028ab04e3c618028352200",
            src: "https://farasa.cao.ir/PluginLib/JDSApp/img/pax",
            width: 942,
            height: 934,
            onClick: onClickFarasa
          }
        ],
    services: [
      {
        title: "رزرو هتل",
        url: `/`
      },
      {
        title: "خرید بلیط پرواز داخلی",
        url: `/flights`
      },
      {
        title: "خرید بلیط پرواز خارجی",
        url: `/inter-flights`
      },
      {
        title: "خرید بلیط اتوبوس",
        url: `/bus`
      },
      {
        title: "اجاره ویلا",
        url: `/villa`
      }
    ],

    moreInfo: isChannel(["snapp-ir"])
      ? [
          {
            title: "درباره‌ ما",
            url: `/about`
          },
          {
            title: "تماس با ما",
            url: `/contact`
          }
        ]
      : [
          {
            title: "درباره‌ ما",
            url: `/about`
          },
          {
            title: "تماس با ما",
            url: `/contact`
          },
          {
            title: "قوانین و مقررات",
            url: `/policy`
          },
          ...(isChannel(["ads"])
            ? []
            : [
                {
                  title: "فرصت های شغلی",
                  url: "https://careers.snapptrip.com"
                }
              ])
        ],
    links: [
      {
        title: "فروش سازمانی",
        url: `https://b2b.snapptrip.com`,
        nofollow: true
      },
      ...(isChannel(["website"])
        ? [
            {
              title: "پنل میزبان ویلا",
              url: `https://myvilla.snapptrip.com`,
              nofollow: true
            }
          ]
        : []),
      {
        title: "بلاگ اسنپ",
        url: `/blog`
      },
      {
        title: "قوانین کنسلی",
        url: `/policy`
      }
    ],
    linksBadgs: [
      {
        title: "بلیط چارتر",
        url: `/charter`
      },
      {
        title: "بلیط تهران مشهد",
        url: `/flights/THR-tehran/MHD-mashhad`
      },
      {
        title: "بلیط تهران استانبول",
        url: `/inter-flights/IKA_Tehran/IST_Istanbul`
      },
      {
        title: "هتل داریوش کیش",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%DA%A9%DB%8C%D8%B4/%D9%87%D8%AA%D9%84-%D8%AF%D8%A7%D8%B1%DB%8C%D9%88%D8%B4`
      },
      {
        title: " هتل اصفهان",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%D8%A7%D8%B5%D9%81%D9%87%D8%A7%D9%86`
      },
      {
        title: "هتل شیراز",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%D8%B4%DB%8C%D8%B1%D8%A7%D8%B2`
      },
      {
        title: "هتل اسپیناس پالاس",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%D8%AA%D9%87%D8%B1%D8%A7%D9%86/%D9%87%D8%AA%D9%84-%D8%A7%D8%B3%D9%BE%DB%8C%D9%86%D8%A7%D8%B3-%D9%BE%D8%A7%D9%84%D8%A7%D8%B3-%DA%A9%D9%84%DA%A9%D8%B3%DB%8C%D9%88%D9%86-%D9%84%D9%88%DA%A9%D8%B3-%DA%AF%D8%B1%D9%88%D9%87-%D9%87%D8%AA%D9%84-%D9%87%D8%A7%DB%8C-%D8%A7%D8%B3%D9%BE%DB%8C%D9%86%D8%A7%D8%B3`
      },
      {
        title: "هتل تهران",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%D8%AA%D9%87%D8%B1%D8%A7%D9%86`
      },
      {
        title: "هتل مشهد",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%D9%85%D8%B4%D9%87%D8%AF`
      },
      {
        title: "هتل کیش",
        url: `/%D8%B1%D8%B2%D8%B1%D9%88-%D9%87%D8%AA%D9%84/%DA%A9%DB%8C%D8%B4`
      },
      {
        title: "بلیط لحظه آخری",
        url: `/last-second`
      },
      {
        title: "بلیط تهران دبی",
        url: `/inter-flights/IKA_Tehran/DXB_Dubai`
      }
    ]
  };
};
